import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgGenderMale({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M12.73 2.45c.41 0 .75.34.75.75v3.36a.75.75 0 11-1.5 0v-1.5l-1.74 1.96c.4.61.66 1.33.7 2.11v.21a4.2 4.2 0 11-1.74-3.4l1.75-1.99h-1.5a.75.75 0 01-.75-.65v-.1c0-.41.33-.75.74-.75zm-5.98 4.2a2.7 2.7 0 100 5.39 2.7 2.7 0 000-5.4z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgGenderMale.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgGenderMale.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgGenderMale svgRef={ref} {...props} />);
export default ForwardRef;
